import React, { useEffect, useState } from "react";
import { Button, Col, Container, Row } from "react-bootstrap";
import { Modal, ModalHeader, ModalBody, ModalFooter, Input } from "reactstrap";
import { Link, useNavigate, useParams } from "react-router-dom";
import {
  HELPANDSUPPORTDETAILS,
  SENDREPLY,
  UPDATE_DISPUTE,
} from "../../../../services/ApiCalls";
import { toast } from "react-toastify";
import fileUploader from "../../../../utilities/fileUploader";
import { useTranslation } from "react-i18next";

const HelpDetail = () => {
  const { t } = useTranslation();
  const { id } = useParams();
  const navigate = useNavigate();

  const [data, setData] = useState(null);
  const [imagePreviews, setImagePreviews] = useState([]);
  const [selectedStatus, setSelectedStatus] = useState("Open");
  const [modal, setModal] = useState(false);
  const [message, setMessage] = useState("");
  const [imgLoader, setImgLoader] = useState(false);

  const toggleModal = () => setModal(!modal);

  const DetailData = async () => {
    try {
      let res = await HELPANDSUPPORTDETAILS(id);
      if (res?.data?.status === "success") {
        const fetchedData = res?.data?.data;
        setData(fetchedData);
        setSelectedStatus(fetchedData?.status || "Open");
      } else {
        toast.error(res?.data?.message || t("helpDetail.fetchFailed"));
      }
    } catch (error) {
      toast.error(t("helpDetail.fetchFailed"));
    }
  };

  useEffect(() => {
    DetailData();
  }, [id]);
  const handleStatusChange = (event) => {
    setSelectedStatus(event.target.value);
  };

  const handleSend = async () => {
    const payload = {
      id: data?._id,
      message,
      attachments: imagePreviews,
    };
    try {
      let res = await SENDREPLY(payload);
      if (res?.data?.status === "success" || res?.data?.success === true) {
        toast.success(res?.data?.message || t("helpDetail.replySuccess"));
        setMessage("");
        setImagePreviews([]);
        setModal(false);
        DetailData();
      } else {
        toast.error(res?.data?.message || t("helpDetail.replyFailed"));
      }
    } catch (error) {
      toast.error(t("common.error"));
    }
  };

  const handleDisputeStatus = async () => {
    try {
      let response = await UPDATE_DISPUTE({
        status: selectedStatus,
        ticketId: data?._id,
      });
      if (response?.data?.status === "success") {
        toast.success(response?.data?.message);
        navigate("/help");
      } else {
        toast.error(response?.data?.message || t("helpDetail.updateFailed"));
      }
    } catch (error) {
      toast.error(t("common.error"));
    }
  };
  const handleImageChange = async (e) => {
    setImgLoader(true);
    const files = Array.from(e.target.files);

    const uploadedUrls = [];
    for (let file of files) {
      const res = await fileUploader(file);
      if (res?.url) {
        uploadedUrls.push(res.url);
      }
    }

    setImagePreviews((prev) => [...prev, ...uploadedUrls]);
    setImgLoader(false);
  };

  const handleRemoveImage = (index) => {
    setImagePreviews((prev) => prev.filter((_, i) => i !== index));
  };

  return (
    <section className="helpDetail py-3 position-relative">
      <Container>
        <Modal isOpen={modal} toggle={toggleModal}>
          <ModalHeader toggle={toggleModal}>
            {t("helpDetail.sendReply")}
          </ModalHeader>
          <ModalBody>
            <label className="form-label fw-bold text-muted ps-2 m-0">
              {t("helpDetail.writeMessage")}
            </label>
            <Input
              type="textarea"
              placeholder={t("helpDetail.messagePlaceholder")}
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              rows={4}
            />

            <Col lg="12" className="my-2">
              <div className="py-2">

                <label className="form-label fw-bold text-muted ps-2 m-0">
                  {t("helpDetail.uploadImages")}
                </label>

                <div
                  className="border border-2 border-dashed rounded d-flex flex-column align-items-center justify-content-center p-4 bg-light"
                  style={{ cursor: "pointer", minHeight: "140px" }}
                  onClick={() =>
                    document.getElementById("imageUploadInput").click()
                  }
                >
                  <p className="m-0 text-muted">
                    {t("helpDetail.uploadHint")}
                  </p>
                  <input
                    id="imageUploadInput"
                    type="file"
                    accept="image/*"
                    multiple
                    className="d-none"
                    onChange={handleImageChange}
                  />
                </div>

                <div className="d-flex flex-wrap gap-2 mt-3">
                  {imgLoader ? (
                    <p>Uploading...</p>
                  ) : (
                    imagePreviews?.map((src, i) => (
                      <div
                        key={i}
                        style={{
                          width: 120,
                          height: 120,
                          position: "relative",
                        }}
                        className="border rounded overflow-hidden shadow-sm"
                      >
                        <img
                          src={src}
                          alt={`preview-${i}`}
                          className="w-100 h-100 object-fit-cover"
                        />
                        <button
                          type="button"
                          className="btn btn-sm btn-danger position-absolute top-0 end-0 m-1 rounded-circle"
                          onClick={() => handleRemoveImage(i)}
                        >
                          ✕
                        </button>
                      </div>
                    ))
                  )}
                </div>
              </div>
            </Col>
          </ModalBody>

          <ModalFooter>
            <Button
              color="primary"
              onClick={handleSend}
              disabled={!message.trim()}
            >
              {t("common.submit")}
            </Button>
            <Button color="secondary" onClick={toggleModal}>
              {t("common.cancel")}
            </Button>
          </ModalFooter>
        </Modal>

        <Row>
          <Col lg="12">
            <div className="d-flex align-items-center gap-10">
              <Link
                to="/help"
                className="border d-flex align-items-center p-2 rounded"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="12"
                  height="12"
                  viewBox="0 0 10 16"
                  fill="none"
                >
                  <path
                    d="M8.64707 0.473344C8.55514 0.381188 8.44594 0.308072 8.32572 0.258184C8.20549 0.208296 8.07661 0.182617 7.94644 0.182617C7.81628 0.182617 7.68739 0.208296 7.56717 0.258184C7.44694 0.308072 7.33774 0.381188 7.24582 0.473344L0.667065 7.05209C0.593675 7.12533 0.53545 7.21233 0.495723 7.3081C0.455996 7.40387 0.435547 7.50654 0.435547 7.61022C0.435547 7.7139 0.455996 7.81657 0.495723 7.91234C0.53545 8.00811 0.593675 8.0951 0.667065 8.16834L7.24582 14.7471C7.63373 15.135 8.25915 15.135 8.64707 14.7471C9.03498 14.3592 9.03498 13.7338 8.64707 13.3458L2.9154 7.60626L8.65498 1.86668C9.03498 1.48668 9.03498 0.853344 8.64707 0.473344Z"
                    fill="#E8307A"
                    stroke="#E8307A"
                    strokeWidth="0.2"
                  />
                </svg>
              </Link>
              <h4 className="mb-0 py-3 fw-bold">
                {t("helpDetail.detail")}
              </h4>
            </div>
          </Col>

          <Col lg="12" className="my-2">
            <div
              className="formWrpper px-lg-5 p-md-4 p-3 rounded"
              style={{ background: "#EEEEEE" }}
            >
              <Row className="justify-content-between">
                <Col md={6} className="my-2">
                  <ul className="list-unstyled ps-0 mb-0">
                    <li className="py-3 d-flex align-items-center gap-10">
                      <p className="m-0 themeBlue fw-sbold w-50">{t("helpDetail.name")}</p>
                      <h6 className="m-0 text-muted fw-bold w-50">
                        {[data?.raisedBy?.first_name, data?.raisedBy?.last_name]
                          .filter(Boolean)
                          .join(" ") || "-"}
                      </h6>
                    </li>
                    <li className="py-3 d-flex align-items-center gap-10">
                      <p className="m-0 themeBlue fw-sbold w-50">{t("helpDetail.email")}:</p>
                      <h6 className="m-0 text-muted fw-bold w-5">
                        {data?.raisedBy?.email || "-"}
                      </h6>
                    </li>
                    <li className="py-3 d-flex align-items-center gap-10">
                      <p className="m-0 themeBlue fw-sbold w-50">{t("common.status")}:</p>
                      <h6 className="m-0 text-muted fw-bold w-50">
                        {data?.status || "-"}
                      </h6>
                    </li>
                  </ul>
                </Col>
                <Col md={6} className="my-2">
                  <ul className="list-unstyled mb-0">
                    <li className="py-3 d-flex align-items-center gap-10">
                      <p className="m-0 themeBlue fw-sbold w-50">{t("helpDetail.category")}:</p>
                      <p className="m-0 text-muted fw-bold w-50">
                        {data?.category || "-"}
                      </p>
                    </li>
                    <li className="py-3 d-flex align-items-center gap-10">
                      <p className="m-0 themeBlue fw-sbold w-50">{t("helpDetail.role")}:</p>
                      <h6 className="m-0 text-muted fw-bold w-50">
                        {data?.role || "-"}
                      </h6>
                    </li>
                    <li className="py-3 d-flex align-items-start gap-10">
                      <p className="m-0 themeBlue fw-sbold w-50">
                        {t("helpDetail.description")}:
                      </p>
                      <p
                        className="m-0 text-muted w-50"
                        style={{ fontSize: 12, lineHeight: "18px" }}
                      >
                        {data?.description || "-"}
                      </p>
                    </li>
                  </ul>
                </Col>
                <button
                  onClick={toggleModal}
                  className="replyBtn commonBtn GreyBtn w-auto mx-auto"
                >
                  {t("helpDetail.reply")}
                </button>
              </Row>
            </div>
          </Col>


          {data?.status?.toLowerCase() !== "closed" && (
            <>
              <Col lg="6" className="my-2">
                <ul className="list-unstyled ps-0 mb-0">
                  <li className="py-3 d-flex align-items-start gap-10">
                    <p className="m-0 themeBlue fw-sbold w-25">
                      Mark Status as:
                    </p>
                    <ul className="list-unstyled ps-0 mb-0 d-flex align-items-center gap-10">
                      {["Open", "In Progress", "Closed", "Resolved"].map(
                        (status) => (
                          <li
                            key={status}
                            className="d-flex align-items-center gap-2"
                          >
                            <input
                              name="status"
                              type="radio"
                              id={status}
                              value={status}
                              checked={selectedStatus === status}
                              onChange={handleStatusChange}
                            />
                            <label
                              htmlFor={status}
                              className="form-label m-0 fw-sbold text-muted text-nowrap"
                            >
                              {status.charAt(0).toUpperCase() + status.slice(1)}
                            </label>
                          </li>
                        )
                      )}
                    </ul>
                  </li>
                </ul>
              </Col>

              <Col lg="12" className="mt-3">
                <Button
                  className="btn commonBtn GreyBtn w-auto mx-auto"
                  onClick={handleDisputeStatus}
                >
                  {t("helpDetail.updateStatus")}
                </Button>

              </Col>
            </>
          )}
        </Row>
      </Container>
    </section>
  );
};

export default HelpDetail;
